var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCsv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.217,
    height: 17.061,
    viewBox: "0 0 14.217 17.061",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "csv",
    transform: "translate(-12.5 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64109",
    "data-name": "Path 64109",
    d: "M22.336,5.535A1.539,1.539,0,0,0,21.046,5H13.634C12.82,5,12.5,5.32,12.5,6.134V20.926c0,.814.32,1.134,1.134,1.134H25.583c.814,0,1.134-.32,1.134-1.134V10.672a1.538,1.538,0,0,0-.535-1.291Zm3.389,15.231c0,.217-.085.3-.3.3H13.795c-.217,0-.3-.085-.3-.3V17.1H25.725Zm-8.517-5.153a1.876,1.876,0,0,0,.623-.108l.113.584a2.134,2.134,0,0,1-.849.142,1.574,1.574,0,0,1-1.733-1.655,1.687,1.687,0,0,1,1.807-1.757,1.952,1.952,0,0,1,.815.147l-.152.594a1.619,1.619,0,0,0-.628-.123,1,1,0,0,0-1.056,1.095A.988.988,0,0,0,17.209,15.613Zm2.051-.82c-.55-.191-.908-.5-.908-.977,0-.565.471-1,1.252-1a2.028,2.028,0,0,1,.845.167l-.167.6a1.576,1.576,0,0,0-.692-.157c-.324,0-.481.147-.481.319,0,.211.187.3.614.466.584.216.859.521.859.987,0,.555-.427,1.026-1.335,1.026a2.165,2.165,0,0,1-.938-.2l.152-.619a1.907,1.907,0,0,0,.83.206c.344,0,.525-.142.525-.358S19.658,14.936,19.26,14.793Zm1.546-1.92h.82l.4,1.4c.113.393.216.771.295,1.183h.015c.083-.4.186-.79.3-1.168l.422-1.414h.8L22.74,16.183h-.874Zm4.919-.919H13.492V6.295c0-.217.085-.3.3-.3h7.553c.108,0,.151.043.151.151v2.94c0,.814.32,1.134,1.134,1.134h2.94c.109,0,.151.043.151.151Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsv);
export default __webpack_public_path__ + "static/media/csv.8d25baa3feacb2a77d5b540ef527d5c1.svg";
export { ForwardRef as ReactComponent };